export enum CustomCurrency {
    ISK = 'kr'
 }

 export enum CustomLocaleReplacement {
    IS = 'de-DE' 
 }